import { Outlet, useLocation } from 'react-router';
import { AppHeader } from './AppHeader.jsx';
import { Sidebar } from './Sidebar.jsx';
import { TabBar } from './TabBar.jsx';
import { useEffect } from 'react';
import { trackEvent } from '../../core/analytics/tracker.js';
import { useAuthStore } from '../../core/stores/authStore.js';
import { PwaInstallPrompt } from '../pwa/PwaInstallPrompt.jsx';
import { PortraitOnlyGuard } from './PortraitOnlyGuard.jsx';
import { usePortraitOrientationLock } from '../../hooks/useScreenOrientation.js';
import { isPhoneDevice, supportsOrientationLock } from '../../features/install/utils.js';

function isChatDetailRoute(pathname) {
  return /^\/chat\/[^/]+$/.test(pathname) && pathname !== '/chat/new';
}

export function AppShell() {
  const location = useLocation();
  const hideAppHeader = isChatDetailRoute(location.pathname);
  const currentUserId = useAuthStore((s) => s.currentUser?.id);

  usePortraitOrientationLock(isPhoneDevice() && supportsOrientationLock());

  useEffect(() => {
    // Count app usage (one per app shell mount/refresh).
    trackEvent({ category: 'App', action: 'AppVisit', userId: currentUserId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-surface md:flex">
      <Sidebar className="hidden md:flex" />
      <div
        className={`flex min-w-0 flex-1 flex-col md:ml-64 ${hideAppHeader ? '' : 'safe-top md:safe-top-0'}`}
      >
        {!hideAppHeader && <AppHeader />}
        <Outlet />
      </div>
      <PwaInstallPrompt />
      <PortraitOnlyGuard />
    </div>
  );
}

export function MainLayout() {
  return (
    <>
      <div className="safe-bottom flex-1 md:safe-bottom-0">
        <Outlet />
      </div>
      <TabBar />
    </>
  );
}
